<template>
  <div class="menu">
    <div class="shouye" @click="goto" :class="show ? 'shouye1' : ''">首页</div>
    <!-- <div class="product" :class="show ? 'shouye2' : ''">
      <div class="gsjs" @click="gotoproductH5">公司介绍</div>
      <div class="app-list">
        <div class="app" @click="gotoh5pos">收银系统</div>
        <div class="app" @click="gotoh5goBei">智慧零售</div>
        <div class="app" @click="gotoh5diBei">订货平台</div>
      </div>
    </div> -->
    <!-- <div class="shouye" @click="gotoh5support" :class="show ? 'shouye3' : ''">
      客户支持
    </div> -->
    <div class="shouye" @click="gotodw" :class="show ? 'shouye4' : ''">
      应用下载
    </div>
    <!-- <div class="shouye" @click="gotolxwm" :class="show ? 'shouye5' : ''">
      联系我们
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    //是否显示弹窗
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    goto() {
      if (this.$route.name == "h5index") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5index",
      });
      this.setShow();
    },
    gotoh5pos() {
      if (this.$route.name == "h5pos") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5pos",
      });
      this.setShow();
    },
    gotoh5support() {
      if (this.$route.name == "h5support") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5support",
      });
      this.setShow();
    },
    gotoh5goBei() {
      if (this.$route.name == "h5goBei") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5goBei",
      });
      this.setShow();
    },
    gotoh5diBei() {
      if (this.$route.name == "h5diBei") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5diBei",
      });
      this.setShow();
    },
    gotoproductH5() {
      if (this.$route.name == "h5product") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5product",
      });
      this.setShow();
    },
    gotodw() {
      if (this.$route.name == "h5download") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5download",
      });
      this.setShow();
    },
    gotolxwm() {
      if (this.$route.name == "h5contactus") {
        this.setShow();
        return;
      }
      this.$router.push({
        name: "h5contactus",
      });
      this.setShow();
    },
    setShow() {
      this.$emit("setShow", false);
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  .shouye {
    position: relative;
    right: -750px;
    opacity: 0;
    height: 120px;
    width: 750px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: right;
    padding: 0 64px;
    font-size: 34px;
    line-height: 42px;
    color: #292929;
  }
  .product {
    right: 750px;
    opacity: 0;
    width: 750px;
    padding: 0 64px;
    height: 148px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    border-bottom: 1px solid #cccccc;

    .gsjs {
      font-size: 34px;
      line-height: 42px;
      color: #292929;
      margin-bottom: 16px;
    }
    .app-list {
      display: flex;
      .app {
        margin-left: 16px;
      }
    }
  }
  .shouye1 {
    opacity: 1;
    right: 0;
    transition: all 0.5s;
    border-bottom: 1px solid #cccccc;
  }
  .shouye2 {
    opacity: 1;
    right: 0;
    transition: all 0.5s 0.2s;
    border-bottom: 1px solid #cccccc;
  }
  .shouye3 {
    opacity: 1;
    right: 0;
    transition: all 0.5s 0.4s;
    border-bottom: 1px solid #cccccc;
  }
  .shouye4 {
    opacity: 1;
    right: 0;
    transition: all 0.5s 0.6s;
    border-bottom: 1px solid #cccccc;
  }
  .shouye5 {
    right: 0;
    opacity: 1;
    transition: all 0.5s 0.8s;
    border-bottom: 1px solid #cccccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/menu.vue